import { NumberInput } from '@components/NumberInput';
import { Label } from '@components/styled/Label.styled';
import { NoteIcon } from '@src/assets';
import React from 'react';
import { Chip } from './Chip';
import * as styled from './styled/OwnerHoldsGroup.styled';
import { TitleGroup } from './TitleGroup';

export const OwnerHoldsGroup: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    return (
        <styled.OwnerHoldsGroup>
            <TitleGroup
                title="Expected Owner Usage"
                Icon={NoteIcon}
                Chip={<Chip label="optional" variant="caution" />}
            />
            <div>Please enter the total number of days for Owner Holds expected each year.</div>
            <styled.Wrapper>
                <NumberInput disabled={disabled} name="num_owner_holds" />
                <Label>days</Label>
            </styled.Wrapper>
        </styled.OwnerHoldsGroup>
    );
};
